/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";

import axios from "axios";

import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { GET_MY_INVITED_SECTIONS } from "../graphql";
import { VApplication } from "../../../application";
import moment from "moment-timezone";
import config from "../config/settings.config.json";

interface Presentation {
  id: string;
  country: string;
  createdAt: string;
  name: string;
}

interface Section {
  id: string;
  name: string;
}

interface SectionOptType {
  name: string;
}

interface InvitedSection {
  presentation: Presentation;
  sections: Section[];
  sectionOptType: SectionOptType[];
  partition: string;
}

interface PartitionOption {
  id: string;
  label: string;
}

interface SectionAndSectionOptType {
  id: string;
  name: string;
  sectionSpecificSectionOptType: SectionOptType[];
}

interface Output {
  presentation: Presentation;
  partitionOption: PartitionOption[];
  defaultSectionOptType: SectionOptType[];
  specialReserveSectionOptType: SectionOptType[];
  sectionsAndSectionOptType: SectionAndSectionOptType[];
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IPresentationListsMethods extends IPluginMethodMap {
  getPresentationListsProps(args: any): Promise<any>;
}

export class PresentationListsService implements IAgentPlugin {
  readonly methods: IPresentationListsMethods;

  constructor() {
    this.methods = {
      getPresentationListsProps: this.getPresentationListsProps.bind(this),
    };
  }

  async getPresentationListsProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");

    try {
      if (client) {
        const res = await client.query({
          query: GET_MY_INVITED_SECTIONS,
          variables: {
            filter: {
              year: {
                eq: "2024",
              },
              status: {
                eq: "active",
              },
            },
          },
          fetchPolicy: "network-only",
        });
        console.log("get Presentation i sales report======", res?.data);
        return {
          ...config,
          typeOfSearch: this.formatSetting(
            res?.data?.getPresentations?.content
          ),
        };
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
  private formatSetting(users: any[]): any {
    let _rowData: any = [];
    let dummy_presenation: any = [];
    if (users && users.length > 0) {
      for (let i = 0; i < users?.length; i++) {
        // console.log(
        //   "data===========",
        //   users[i]?.sections[0]?.presentation?.name
        // );
        let value = users[i]?.sections[0]?.presentation?.name;
        if (value) {
          if (dummy_presenation.includes(value) === false) {
            _rowData.push({
              value: users[i]?.sections[0]?.presentation?.id,
              label: value,
            });
          }

          dummy_presenation.push(value);
        }
      }
    }

    return _rowData;
  }
}
